"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedSharingModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const react_intl_1 = require("react-intl");
const EmbedSharingModal_module_css_1 = __importDefault(require("./EmbedSharingModal.module.css"));
const EmbedStaticCode_1 = require("./EmbedStaticCode");
const react_1 = require("react");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_env_1 = require("@snapchat/web-env");
/**
 * Embed Sharing Modal
 * @param props Props defiend in EmbedSharingModalProps
 */
function EmbedSharingModal(props) {
    const [copied, setCopied] = (0, react_1.useState)(false);
    const [copyError, setCopyError] = (0, react_1.useState)(false);
    const timerRef = (0, react_1.useRef)();
    const url = new URL(props.contentURL);
    let iframeSrcUrl = props.iframeURL;
    if (!iframeSrcUrl) {
        url.pathname += "/embed";
        iframeSrcUrl = url.toString();
    }
    const embedIframeProps = {
        width: "416",
        height: "692",
        style: "border-radius: 40px;",
        embedSrc: iframeSrcUrl,
        contentUrl: props.contentURL,
        title: props.title,
    };
    const copyCode = async () => {
        // eslint-disable-next-line no-restricted-globals
        await (0, web_env_1.getNavigator)()?.clipboard.writeText((0, EmbedStaticCode_1.staticEmbedBlockquote)({ ...embedIframeProps }));
    };
    const copyCodeToClipboard = () => {
        setCopyError(false);
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType: props.pageType,
            actionName: web_blizzard_reporting_1.WebActionName.ButtonClick,
            deepLinkUrl: props.contentURL,
            destination: iframeSrcUrl,
            actionSource: web_blizzard_reporting_1.WebActionSource.Embed_CopyCodeClick,
            webClientId: props.webClientId,
        });
        copyCode()
            .then(() => {
            setCopied(true);
            timerRef.current = (0, web_env_1.getWindow)()?.setTimeout(() => setCopied(false), 3000); // reset copied state after 3 seconds
        })
            .catch(() => {
            setCopied(false);
            setCopyError(true);
        });
    };
    (0, react_1.useEffect)(() => () => clearTimeout(timerRef.current), []);
    const closeModal = () => props.setShowModal(false);
    const title = ((0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H3", children: (0, jsx_runtime_1.jsxs)("span", { className: EmbedSharingModal_module_css_1.default.titleContainer, children: [(0, jsx_runtime_1.jsx)("span", { className: EmbedSharingModal_module_css_1.default.title, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "faBe0K", description: "Embed Sharing modal title", defaultMessage: "Embed" }) }), (0, jsx_runtime_1.jsx)(web_sds_c_1.ButtonOrLink, { className: EmbedSharingModal_module_css_1.default.crossIcon, onClick: closeModal, children: (0, jsx_runtime_1.jsx)(web_core_ui_1.CrossIcon, { size: web_core_ui_1.Sizes.Medium }) })] }) }));
    return ((0, jsx_runtime_1.jsx)("div", { className: EmbedSharingModal_module_css_1.default.modalContainer, children: props.showModal && ((0, jsx_runtime_1.jsx)(web_core_ui_1.ModalWithActions, { bodyClassName: EmbedSharingModal_module_css_1.default.modalBodyContainer, closeModal: closeModal, headerEl: title, footerEl: (0, jsx_runtime_1.jsx)("div", { className: EmbedSharingModal_module_css_1.default.buttonContainer, children: (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: copyCodeToClipboard, className: EmbedSharingModal_module_css_1.default.actionButton, children: copied ? ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "UCXOkQ", description: "Embed code copied", defaultMessage: "Copied!" })) : ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "zMWPhb", description: "Copy Embed code button", defaultMessage: "Copy code" })) }) }), bodyEl: (0, jsx_runtime_1.jsxs)("div", { className: EmbedSharingModal_module_css_1.default.bodyContainer, children: [copyError && ((0, jsx_runtime_1.jsx)("p", { className: EmbedSharingModal_module_css_1.default.copyError, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "8U65x8", description: "Copy Error", defaultMessage: "Error occurred while copying embed code, Please try again." }) })), (0, jsx_runtime_1.jsx)("p", { className: EmbedSharingModal_module_css_1.default.termsOfUseText, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "ZNiFih", description: "Snapchat's Public Content Display Terms", defaultMessage: "By using this embed, You agree to Snapchat's {termsOfUseLink}", values: {
                                termsOfUseLink: ((0, jsx_runtime_1.jsx)("a", { className: EmbedSharingModal_module_css_1.default.termsOfUse, href: "https://snap.com/policies/pcd", target: "_blank", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "sS8dgY", defaultMessage: "Public Content Display Terms", description: "Public Content Display Terms" }) })),
                            } }) }), (0, jsx_runtime_1.jsx)("textarea", { "data-testid": "embedTextArea", className: EmbedSharingModal_module_css_1.default.codeBlock, value: `${(0, EmbedStaticCode_1.staticEmbedBlockquote)({
                            ...embedIframeProps,
                        })}`, readOnly: true })] }) })) }));
}
exports.EmbedSharingModal = EmbedSharingModal;
//# sourceMappingURL=EmbedSharingModal.js.map